import styled, { createGlobalStyle } from 'styled-components';

import { COLORS } from '@theme/colors';
import { Z_INDEX } from '@utils/constants';
import { media } from '@theme/media';
import { FONT_SIZE, LETTER_SPACING, typography } from '@theme/font';
import { TextField as TextFieldForm } from '@components/form';
import { OFFSET } from '@theme/helpers';

export const ModalGlobalStyles = createGlobalStyle`
  .ReactModal__Content {
    transform: translate(-50%, -200%);
    transition: transform 200ms ease-in-out;
  }

  .ReactModal__Content--after-open {
    transform: translate(-50%, -50%);
  }

  .ReactModal__Content--before-close{
    transform: translate(-50%, -200%);
  }

  .ReactModal__Overlay {
    opacity: 0;
    transition: opacity 200ms ease-in-out;
  }

  .ReactModal__Overlay--after-open{
    opacity: 1;
  }

  .ReactModal__Overlay--before-close{
    opacity: 0;
  }
`;

export const ModalContent = styled.div`
  width: 100%;
  padding: 0 ${OFFSET.S};

  ${media.tablet} {
    width: 540px;
  }
`;

export const Title = styled.div`
  height: 85px;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid ${COLORS.BLACK};
`;

export const modalStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    padding: '0',
    border: 'none',
    borderRadius: '0',
    width: '540px',
    maxWidth: '100%',
  },
  overlay: {
    zIndex: Z_INDEX.COOKIE_BANNER,
    backgroundColor: COLORS.BLACK50,
  },
};

export const CloseModal = styled.button`
  position: absolute;
  width: 44px;
  overflow: hidden;
  cursor: pointer;
  ${typography({ size: FONT_SIZE.XS })};
  z-index: 1;
  padding: 0;
  right: 0;
  left: auto;
  height: ${OFFSET.M};
  top: 0;

  &:before {
    content: '';
    position: absolute;
    display: block;
    width: 20px;
    height: 20px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 100%;
    background-color: ${COLORS.WHITE};
    z-index: -1;
  }

  &:after {
    content: '\\2715';
  }

  &:hover {
    &:before {
      background-color: ${COLORS.WILD_SAND};
    }
  }
`;

export const Form = styled.form`
  max-height: 68vh;
  overflow-y: auto;
  padding-bottom: ${OFFSET.S};
`;

export const Subtitle = styled.div`
  ${typography({ spacing: LETTER_SPACING.S })};
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
  padding: ${OFFSET.XS} 0;
  border-bottom: 1px solid ${COLORS.BLACK};
  margin: ${OFFSET.M} 0;
`;

export const TextField = styled(TextFieldForm)`
  height: 100%;
  label {
    min-width: auto;
  }
`;

export const Row = styled.div<{ columns?: number }>`
  display: grid;
  grid-template-columns: ${({ columns = 1 }) => (columns === 3 ? '1fr auto 1fr' : `repeat(${columns}, 1fr)`)};
  grid-gap: ${OFFSET.S};
  align-items: center;

  ${TextField} {
    margin-bottom: 0;
  }
`;

export const SelectWrapper = styled.div`
  position: relative;
`;

export const DateWrapper = styled.div`
  position: relative;
  margin-bottom: ${OFFSET.M};

  .react-datepicker__input-container input {
    ${typography({})};
    border: none;
    padding: ${OFFSET.XS} 0;
    border-top: 1px solid ${COLORS.BLACK};
    border-bottom: 1px solid ${COLORS.BLACK};
    width: 100%;
    background-color: transparent;
    color: ${COLORS.BLACK};

    &::placeholder {
      color: ${COLORS.BLACK};
    }
  }
`;
